export default {
  overview: 'Overview',
  today_overview: 'Today\'s Overview',
  balance: 'Balance',
  in_transit: 'In Transit',
  abd_balance: 'Average Daily Balance',
  total_transaction: 'Total Transaction',
  transaction_count: 'Transaction Count',
  transaction_amount: 'Transaction Amount',
  transaction_fee: 'Transaction Fee',
  payin: 'Payin',
  payout: 'Payout',
  number: 'Transaction Count',
  amount: 'Amount',
  payin_number: 'Payin Count',
  payout_number: 'Payout Count',
  payin_amount: 'Payin Amount',
  payout_amount: 'Payout Amount',
  transaction_trends: 'Transaction Trends',
  all: 'All',
  fee: 'Fee',
  today: 'Today',
  week: 'Last 7 days',
  month: 'Last 30 days',
  commission: 'Commission'
}
